/**
 * COPYRIGHT NOTICE
 * This file is categorized as "Custom Source Code"
 * and is subject to the terms and conditions defined in the
 * "LICENSE.txt" file, which is part of this source code package.
 */
import ScreenContainer from '../OneHat/components/ScreenContainer';
import QuestionsAccorion from '../components/QuestionsAccorion';
import _ from 'lodash';

export default function Questions(props) {
	const {
			navigation,
			route,
		} = props,
		safeArea = route.params && route.params.safeArea;
	
	return <ScreenContainer screenName="Questions" safeArea={safeArea}>
				<QuestionsAccorion navigation={navigation} />
			</ScreenContainer>;
}
